import SettingTypes from '@/utils/setting-types'
import { uuid } from '@/utils/foundation'

export default {
  name: 'image-text-nav',
  label: {
    title: '图文导航',
    icon: require('@/assets/icon-component-label_ImageTextNavigator.png'),
    limit: 10
  },
  sort: 4,
  data: {
    // 导航列表
    navList: ['一', '二', '三', '四'].map(item => ({
      __key: uuid(),
      image: '',
      title: `导航${item}`,
      link: ''
    })),
    // 导航类型【image-text：图文，text：文字】
    nav_type: 'image-text',
    // 导航样式
    nav_style: 'fixed',
    // 一屏显示数量
    nav_show_num: 4,
    // 指示点颜色
    swiper_color: '#f42424',
    // 滑动条颜色
    scroll_color: '#f42424',
    // 背景颜色
    background_color: '#ffffff',
    // 文字颜色
    text_color: '#303133',
    // 页面边距
    page_edge: 20,
    // 页面圆角
    page_radius: 20,
    // 图片缩放大小
    image_scale: 0.66,
    // 图片圆角
    image_radius: 30,
    // 显示弹窗
    show_popup: false,
    // 弹窗类型
    popup_style: 'TEXT',
    // 弹窗图片
    popup_image_data: '',
    // 弹窗文字
    popup_text_data: '',
    // 背景颜色
    border_color: 'rgba(255, 255, 255, 0)',
    // 页面内边距
    page_margin_edge: 0,
    // 页面圆角
    page_margin_radius: 0,
    // 内边距背景颜色
    margin_border_color: 'rgba(255, 255, 255, 0)',
  },
  settings: {
    navList: {
      type: SettingTypes.custom,
      component_name: 'ImageTextNavSelector'
    },
    nav_type: {
      type: SettingTypes.radio_button,
      label: '导航类型',
      options: [
        { label: '图文导航', value: 'image-text' },
        { label: '文字导航', value: 'text' }
      ]
    },
    nav_style: {
      type: SettingTypes.select,
      label: '导航样式',
      options: [
        { label: '固定', value: 'fixed', icon: 'rb-icon-fixed' },
        { label: '横向滑动', value: 'scroll', icon: 'rb-icon-scroll' },
        { label: '多排', value: 'more', icon: 'rb-icon-feature' },
        { label: '双排轮播', value: 'more-swiper', icon: 'rb-icon-feature' },
        { label: '双排滑动', value: 'more-scroll', icon: 'rb-icon-feature' },
        { label: '同行固定', value: 'peer-fixed' }
      ]
    },
    swiper_color: {
      type: SettingTypes.color_picker,
      label: '指示点颜色',
      default: '#f42424',
      show: data => data.nav_style === 'more-swiper'
    },
    scroll_color: {
      type: SettingTypes.color_picker,
      label: '滑动条颜色',
      default: '#f42424',
      show: data => data.nav_style === 'more-scroll'
    },
    nav_show_num: {
      type: SettingTypes.select,
      label: '一屏显示',
      show: data => data.nav_style !== 'fixed' && data.nav_style !== 'peer-fixed',
      options: [...new Array(10)].map((item, index) => ({
        label: `${index + 1}个导航`,
        value: index + 1
      }))
    },
    page_edge: {
      type: SettingTypes.slider,
      label: '页面边距',
      props: {
        min: 0,
        max: 30
      }
    },
    page_radius: {
      type: SettingTypes.slider,
      label: '页面圆角',
      props: {
        min: 0,
        max: 750
      }
    },
    image_scale: {
      type: SettingTypes.slider,
      label: '图片缩放',
      props: {
        min: 0.3,
        max: 1,
        step: 0.01
      }
    },
    image_radius: {
      type: SettingTypes.slider,
      label: '图片圆角',
      props: {
        min: 0,
        max: 750
      }
    },
    background_color: {
      type: SettingTypes.color_picker,
      label: '背景颜色',
      default: '#ffffff'
    },
    text_color: {
      type: SettingTypes.color_picker,
      label: '文字颜色',
      default: '#000000',
      space_line: true
    },
    border_color: {
      type: SettingTypes.color_picker,
      label: '边框颜色',
      default: '#ffffff'
    },
    page_margin_edge: {
      type: SettingTypes.slider,
      label: '页面内边距',
      props: {
        min: 0,
        max: 30
      }
    },
    page_margin_radius: {
      type: SettingTypes.slider,
      label: '页面圆角',
      props: {
        min: 0,
        max: 750
      }
    },
    margin_border_color: {
      type: SettingTypes.color_picker,
      label: '内边距边框颜色',
      default: '#000000',
      space_line: true
    },
    is_login: {
      type: SettingTypes.boolean,
      label: '是否需要登录',
      props: {
        activeText: '是',
        inactiveText: '否'
      }
    },
    show_popup: {
      type: SettingTypes.boolean,
      label: '弹窗提示类型（未设置链接时生效）',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        key: 'popup_style',
        type: 'radio',
        options: [
          { label: '图片', value: 'IMAGE' },
          { label: '文字', value: 'TEXT' }
        ],
        custom_component_name: 'NavSettingCustomPopupStyle'
      }
    }
  }
}
